import React from 'react';
import ProfileEditContainer from '../../containers/profilemng/ProfileEditContainer';

const ProfileEditPage = () => {
  return <ProfileEditContainer />;
};

export default ProfileEditPage;
